import type { PrerenderHeaders } from '../cloudflare/renderToResponseInternal';

export default function skyra() {
    const script = document.createElement('script');
    script.src = 'https://survey.skyra.no/skyra-survey.js';
    window.SKYRA_CONFIG = {
        org: 'vinmonopolet',
    };
    document.body.appendChild(script);
}

export function skyraCspHeaders(headers: PrerenderHeaders) {
    headers.addCsp('connect-src', 'https://ingest.skyra.no/');
    headers.addCsp('script-src', 'https://survey.skyra.no/');
}
